// 登陆，退出
export const LOGIN = 'LOGIN'
export const WXLOGIN = 'WXLOGIN'
export const LOGOUT = 'LOGOUT'
export const SETTLE = 'SETTLE'
export const SELECTADDRESS = 'SELECTADDRESS'
export const REMOVEADDRESS = 'REMOVEADDRESS'
export const SELECTBANK = 'SELECTBANK'
export const REMOVEBANK = 'REMOVEBANK'
export const SELECTINVOICE = 'SELECTINVOICE'
export const REMOVEINVOICE = 'REMOVEINVOICE'